export const statusColors = {
  available: "bg-emerald-100 text-emerald-800 border-emerald-200",
  hired: "bg-amber-100 text-amber-900 border-amber-200",
  maintenance: "bg-red-100 text-red-800 border-red-200",
  active: "bg-[#001A4D]/10 text-[#001A4D] border-[#001A4D]/20",
  returned: "bg-neutral-200 text-neutral-700 border-neutral-300",
  scheduled: "bg-[#001A4D]/10 text-[#001A4D] border-[#001A4D]/20",
  completed: "bg-neutral-200 text-neutral-700 border-neutral-300",
  cancelled: "bg-red-100 text-red-800 border-red-200",
  confirmed: "bg-emerald-100 text-emerald-800 border-emerald-200",
};

export const difficultyColors = {
  Easy: "bg-emerald-100 text-emerald-800",
  Moderate: "bg-amber-100 text-amber-900",
  Hard: "bg-[#001A4D]/10 text-[#001A4D]",
  Expert: "bg-[#0A0A0A] text-[#F5F5F0]",
};

export const StatusBadge = ({ status }) => (
  <span
    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${
      statusColors[status] || "bg-neutral-100 text-neutral-700 border-neutral-200"
    }`}
  >
    {status}
  </span>
);
